import {Component, Input, OnInit} from '@angular/core';
import {TokenService} from '../../../../core/auth';
import {Label, Telemetry} from "../../../../core/models";

@Component({
  selector: 'app-telemetry-event',
  templateUrl: 'telemetry-event.component.html'
})

export class TelemetryEventComponent implements OnInit {
  @Input() telemetry: Telemetry;

  constructor(
    private token: TokenService
  ) {
  }

  ngOnInit() {

  }

}
